import classNames from 'classnames';
import React from 'react';
import SpinIcon from '../../assets/spin.svg';
import { withNativeProps } from '../../utils/native-props';
import { useNewControllableValue } from '../../utils/use-controllable-value';
import { mergeProps } from '../../utils/with-default-props';
var classPrefix = "adm-switch";
var defaultProps = {
  defaultChecked: false
};
export var Switch = function Switch(p) {
  var _classNames;

  var props = mergeProps(defaultProps, p);
  var disabled = props.disabled || props.loading || false;

  var _useNewControllableVa = useNewControllableValue({
    value: props.checked,
    defaultValue: props.defaultChecked,
    onChange: props.onChange
  }),
      checked = _useNewControllableVa[0],
      setChecked = _useNewControllableVa[1];

  return withNativeProps(props, /*#__PURE__*/React.createElement("label", {
    className: classNames(classPrefix, (_classNames = {}, _classNames[classPrefix + "-checked"] = checked, _classNames[classPrefix + "-disabled"] = disabled, _classNames))
  }, /*#__PURE__*/React.createElement("input", {
    type: 'checkbox',
    checked: checked,
    onChange: function onChange(e) {
      disabled || setChecked(e.target.checked);
    },
    disabled: disabled
  }), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-checkbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-handle"
  }, // 禁用状态优先于加载状态
  props.disabled || props.loading && /*#__PURE__*/React.createElement("img", {
    src: SpinIcon,
    className: classPrefix + "-icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-inner"
  }, checked ? props.checkedText : props.uncheckedText))));
};